import React, { Component } from "react";

// import Siema from "siema";
import debounce from "lodash/debounce";
import "./carousel.scss";

import { tns } from "tiny-slider/src/tiny-slider";
import "tiny-slider/dist/tiny-slider.css";

// Pass through settings object as prop to customise
// Available options listed at https://github.com/pawelgrzybek/siema#options
class Carousel extends Component {
  slider = null;
  carousel = null;
  nextButton = null;
  prevButton = null;
  debouncedResize = null;

  build() {
    const { settings, arrows } = this.props;

    if (!this.carousel) {
      return;
    }
    console.log("Settings >>>>>>>>>" , settings);
    const carouselSettings = {
      container: this.carousel,
      items: 1,
      controls: false,
      nav: false,
      mouseDrag: true,
      loop: false,
      disable: false,
      lazyload: true,
      ...settings
    };

    if (arrows) {
      carouselSettings.nextButton = this.nextButton;
      carouselSettings.prevButton = this.prevButton;
    }

    return new tns(carouselSettings);
  }

  goTo = dir => {
    this.slider.goTo(dir);
  };

  shouldComponentUpdate() {
    // Necessary to avoid errors - dom manipulation required for re-renders
    return false;
  }

  componentDidMount() {
    this.slider = this.build();

    if (this.slider && this.props.arrows) {
      this.slider.events.on("indexChanged", this.onUpdate);
      this.onUpdate(this.slider.getInfo());
    }
  }

  onUpdate = evt => {
    if (evt.index + this.props.slidesToShow >= evt.slideCount) {
      this.nextButton.classList.remove("carousel__arrow--active");
    } else {
      this.nextButton.classList.add("carousel__arrow--active");
    }

    if (evt.index > 0) {
      this.prevButton.classList.add("carousel__arrow--active");
    } else {
      this.prevButton.classList.remove("carousel__arrow--active");
    }
  };

  componentWillUnmount() {
    if (this.slider.destroy) {
      this.slider.destroy();
    }
  }

  render() {
    const { desktopEnabled } = this.props;
    return (
      <div
        className={`carousel ${this.props.className || ""} ${
          desktopEnabled ? "carousel--margin" : ""
        }`}
        key={this.props.key}
      >
        <div
          className="carousel__container"
          ref={el => {
            if (this.carousel) {
              return;
            }
            this.carousel = el;
          }}
        >
          {this.props.children}
        </div>
        {this.props.arrows && (
          <button
            className="carousel__arrow carousel__arrow--prev"
            onClick={() => this.goTo("prev")}
            ref={el => {
              if (!el || this.prevButton) {
                return;
              }

              this.prevButton = el;
            }}
          />
        )}
        {this.props.arrows && (
          <button
            className="carousel__arrow carousel__arrow--next carousel__arrow--active"
            onClick={() => this.goTo("next")}
            ref={el => {
              if (!el || this.nextButton) {
                return;
              }

              this.nextButton = el;
            }}
          />
        )}
      </div>
    );
  }
}

export default Carousel;



// WEBPACK FOOTER //
// ./src/components/Carousel/index.js